export var MENU_CLASS_PREFIX = 'Menu';